const Divider = () => {
  return <hr></hr>;
};

export default Divider;
